// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/styles/checkbox-customize/checkbox.css
// module id = 983
// module chunks = 0